import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RecoilRoot } from 'recoil'
import * as Sentry from '@sentry/react'

import './index.css'
import reportWebVitals from './app/reportWebVitals'
import { Router } from './app/Router'
import { Theme } from './app/Theme'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { AuthCodeWrapper } from './auth/AuthCodeWrapper'
import './common/utils/sentry'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: async (error: any) => {
      if (error.request && (error.request.status === 401 || error.request.status === 403)) {
        window.location.reload() // using browser native features instead of react router to get a full page refresh to pick up any new deployments
      }
    },
  }),
})

const container = document.getElementById('app')
const root = createRoot(container!)
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <QueryClientProvider client={queryClient}>
        <RecoilRoot>
          <Theme>
            <AuthCodeWrapper>
              <Router />
            </AuthCodeWrapper>
          </Theme>
        </RecoilRoot>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
